'use client';

import { PublicPageLayout } from '@letsgo/PublicPageLayout';
import Link from 'next/link';
import { Box, Container, Typography, Link as MuiLink, Card, CardContent } from '@mui/material';
import { posts } from '@/content/blog/posts';

function formatDate(dateStr: string): string {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function BlogPage() {
  return (
    <PublicPageLayout>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Typography variant="h4" component="h1" fontWeight={700} mb={1} color="text.primary">
          Blog &amp; Resources
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={4}>
          Tips, product updates, and creator stories from the FloAI team.
        </Typography>
        <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
          {posts.map((post) => (
            <Box component="li" key={post.slug} sx={{ mb: 3 }}>
              <Card variant="outlined" sx={{ overflow: 'hidden' }}>
                <CardContent>
                  <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                    {formatDate(post.date)}
                  </Typography>
                  <MuiLink
                    component={Link}
                    href={`/blog/${post.slug}`}
                    color="primary"
                    sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                  >
                    <Typography variant="h6" component="h2" fontWeight={700}>
                      {post.title}
                    </Typography>
                  </MuiLink>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {post.excerpt}
                  </Typography>
                  <MuiLink component={Link} href={`/blog/${post.slug}`} color="primary" sx={{ mt: 1, display: 'inline-block', fontWeight: 600 }}>
                    Read more →
                  </MuiLink>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Box>
      </Container>
    </PublicPageLayout>
  );
}
